__webpack_require__.p = "/wp-content/themes/dascoachinghaus.ch/dist/";